import React from 'react';

import { Button } from '@/components/Button';

/**
 * ClearFiltersButton - Standard button for clearing table filters
 *
 * Use this component for all "Clear Filters" buttons to ensure
 * consistent sizing (xxs) and styling across the application.
 *
 * @example
 * {hasActiveFilters && <ClearFiltersButton onClick={clearAllFilters} />}
 */
export const ClearFiltersButton: React.FC<{
  onClick: () => void;
  label?: string;
}> = ({ onClick, label = 'Clear Filters' }) => (
  <Button
    styleType="rounded"
    size="xxs"
    className="text-chariot-brand-primary border-none"
    label={label}
    onClick={onClick}
  />
);
